import CONSTANTS from '@/constants/Config.constants'

const ICONS: any = CONSTANTS.ARTIFACTS.PROVIDERS_ICONS
const PATH = '/img/adapter-icons/'

export default class ProviderIconService {
  getIconForProvider(provider: string): string | undefined {
    const icon = ICONS[provider]
    return icon ? `${PATH}${icon}` : undefined
  }
}
